export default __webpack_public_path__ + "static/media/mail.5f84d7c4.svg";